import { Machine } from '@data-terminal/shared-models/machine';
import { Activity } from '@data-terminal/shared-models/operation';
import { TimeModeEntry } from '@data-terminal/shared-models/time-mode-entry.interface';
import { RequestMetadata } from '@data-terminal/utils/helpers';
import { Observable } from 'rxjs';

export interface SignOffDialogData {
    data: Machine[];
    unsubmittedTimeEntries: TimeModeEntry[];
    userId: string;
    otherActivities$: Observable<RequestMetadata<Activity[]>>;
}

export interface SignOffDialogConfig {
    workstations: boolean;
    employees: boolean;
    operations: boolean;
    timeTransfer: boolean;
    summary: boolean;
}

export const SignOffDialogStep = {
    WORKSTATIONS: 'workstations',
    EMPLOYEES: 'employees',
    OPERATIONS: 'operations',
    TIME_TRANSFER: 'timeTransfer',
    SUMMARY: 'summary',
} as const;
export type SignOffDialogStep = (typeof SignOffDialogStep)[keyof typeof SignOffDialogStep];

export const TimeTransferStatus = {
    IDLE: 'IDLE',
    TRANSFERRING: 'TRANSFERRING',
    DONE: 'DONE',
    ERROR: 'ERROR',
} as const;
export type TimeTransferStatus = (typeof TimeTransferStatus)[keyof typeof TimeTransferStatus];

export interface TimeTransferState {
    status: TimeTransferStatus;
    processed: number;
    total: number;
    transferFailed?: boolean;
}

export enum AssistantsSignOff {
    STAY = 'STAY',
    LEAVE = 'LEAVE',
}

export enum OperationActionSignOff {
    PAUSE = 'PAUSE',
    FINISH = 'FINISH',
}

export interface SignOffBaseStepObject {
    machineId: string;
    isValid: boolean;
}

export interface SignOffEmployees extends SignOffBaseStepObject {
    assistantsSignOff: AssistantsSignOff;
    newCaptain?: string;
}

export interface SignOffOperation extends SignOffBaseStepObject {
    goodAmount: number;
    wasteAmount: number;
    comment: string;
    operationAction: OperationActionSignOff;
    runningOperation: string;
}
